import { render, staticRenderFns } from "./OnboardingModal.vue?vue&type=template&id=2610b9ba&scoped=true"
import script from "./OnboardingModal.vue?vue&type=script&lang=js"
export * from "./OnboardingModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingModal.vue?vue&type=style&index=0&id=2610b9ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2610b9ba",
  null
  
)

export default component.exports